import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import RequestDetails from "../../Pages/CompanyPages/RequestDetails";


import CustomerContact from "../../Pages/CompanyPages/CustomerContact";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`,
  };
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

//export default function NavTabs() {
 const NavTabs = ({ selectedOrder,fixingstatus, changeComponent,checkBoxChangeHandler,saveRequestDetails ,togglePop,showModal,assignRequestTo,assignTo,showlocation,modalTogglerHandler, infoLocation,updateLoctaionCord,show,message,setShow,denyRequest }) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          variant="fullWidth"
          value={value}
          onChange={handleChange}
          aria-label="nav tabs example"
        >
          <LinkTab label="Request Info" href="/drafts" {...a11yProps(0)} />
         
        
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <RequestDetails changeComponent={changeComponent} saveRequestDetails={saveRequestDetails} fixingstatus ={fixingstatus} selectedOrder={selectedOrder}  checkBoxChangeHandler={checkBoxChangeHandler} showModal={showModal} togglePop={togglePop} showlocation={showlocation} modalTogglerHandler={modalTogglerHandler} infoLocation={infoLocation} updateLoctaionCord={updateLoctaionCord}  show={show} message={message} setShow={setShow} denyRequest={denyRequest} />
      </TabPanel>
     
    </div>
  );
};
export default NavTabs;
